var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],class:_vm.classObject,on:{"click":_vm.clicked}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }